import { Col, Row } from "react-bootstrap";
import React, { useEffect, useState } from "react";
import CardMeses from "./cards-pagos/CardMeses";
import { useParams } from "react-router-dom";
import { dataAlumno } from "data/apiConection.js/dataAlumnos";

const Pagos = () => {
    const [alumno, setAlumno] = useState({});
    const { id } = useParams()
    
    useEffect(() => {
        const fetchData = async (id) => {
            try {
                const a = await dataAlumno(id, '2025');
                setAlumno(a);
            } catch (error) {
                console.error("Error fetching users:", error);
            }
        };
    
        fetchData(id);
}, [id]);
    return (
        <>
            <Row>
                  <Col>
                   {alumno && <CardMeses father = {alumno} />}
                </Col>
            </Row>
        </>
    );
}

export default Pagos;